import SearchIcon from '@components/icons/search-icon';
import FilterIcon from '@components/icons/filter-icon';
// import { useUI } from '@contexts/ui.context';
import { debounce } from 'lodash';
// import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { drawerAtom } from '@store/drawer-atom';

type Props = {
  searchResultCount: number | undefined;
  filtersVisible: boolean;
  handleFilters: () => void;
  exclude?: string[];
};

const SearchTopBar: React.FC<Props> = ({
  searchResultCount,
  filtersVisible,
  handleFilters,
  exclude = [],
}) => {
  const router = useRouter();

  const [{ view }, setDrawerState] = useAtom(drawerAtom);
  const openCart = () => {
    setDrawerState({
      display: true,
      view: 'DISPLAY_FILTER',
      data: {
        exclude,
      },
    });
  };

  // const selectRef = useRef<HTMLLabelElement>(null);
  const { query, pathname } = router;

  const isFilterSectionOpen = !!view || filtersVisible;

  const { t } = useTranslation('common');
  // const { openSidebar, closeSidebar } = useUI();
  // const handleSidebar = useCallback(
  //   (view: string) => {
  //     return openSidebar({
  //       view,
  //       data: {
  //         searchResultCount: searchResultCount ?? 0,
  //       },
  //     });
  //   },
  //   [searchResultCount],
  // );

  // useEffect(() => {
  //   if (query) {
  //     closeSidebar();
  //   }
  // }, [query]);

  return (
    <div className="flex flex-col gap-6 px-4 py-4 md:px-[100px] md:flex-row justify-between md:items-end ">
      {/* Left Section: Items Count and Search Bar */}
      <div className="w-full flex flex-col md:flex-row md:items-center gap-3 md:gap-10 lg:gap-[150px]">
        {/* Row 1 on mobile: Search / order-2 on desktop */}
        <div className="order-1 md:order-2 flex bg-[#EEEEEE] items-center w-full 2xl:rounded-[18px] rounded-xl gap-5 px-3 py-2 2xl:h-[61px] lg:h-[44px]">
          <SearchIcon className="md:w-3 xl:w-4 md:h-3 xl:h-4 ml-2" />
          <input
            type="text"
            placeholder="Search"
            className="w-full outline-none bg-transparent text-black text-titillium md:text-lg"
            id="search-top-input"
            onBlur={() => {
              const input = document.getElementById('search-top-input');
              if (input) {
                (input as HTMLInputElement).value = (
                  input as HTMLInputElement
                ).value.trim();
              }
            }}
            onChange={debounce((e) => {
              router.push(
                {
                  pathname,
                  query: {
                    ...query,
                    q: e.target.value,
                  },
                },
                undefined,
                { scroll: false },
              );
            }, 300)}
          />
        </div>

        {/* Row 2 on mobile: Count + Filters spaced between / dissolves into flex row on desktop */}
        <div className="order-2 flex items-center justify-between md:contents">
          <div className="md:order-1 text-[#7E7E7E] text-sm md:text-lg flex items-center flex-shrink-0 gap-2">
            {searchResultCount || 0} {t('text-items')}
          </div>

          <div
            className="md:order-3 text-[#7E7E7E] md:min-w-[130px] text-sm md:text-lg mb-1 cursor-pointer flex items-center gap-4 flex-shrink-0"
            onClick={() => {
              if (window.innerWidth < 1500) {
                openCart();
              } else {
                handleFilters();
              }
            }}
          >
            <span>
              {isFilterSectionOpen
                ? t('text-hide-filters')
                : t('text-show-filters')}
            </span>
            <FilterIcon isActive={isFilterSectionOpen} width="22" height="26" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchTopBar;
